export default __webpack_public_path__ + "static/media/MediumCriticaly.c97e4fef.svg";